const containsDigit = (str: any) => {
  return /\d/.test(str);
};

export default containsDigit;
